module.exports = __webpack_public_path__ + "img/baitiao_shopping.62e8fc59.png";